import {
  Navigate,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import LogistaRoute from './LogistaRoute';
import GameLayout from '@/components/layout/GameLayout';
import AdminLayout from '@/components/layout/AdminLayout';
import LogistaLayout from '@/components/layout/LogistaLayout';
import LandingPage from '@/pages/public/LandingPage';
import LoginPage from '@/pages/public/LoginPage';
import RegisterPage from '@/pages/public/RegisterPage';
import MapExplorePage from '@/pages/game/MapExplorePage';
import MissionsPage from '@/pages/game/MissionsPage';
import CharactersPage from '@/pages/game/CharactersPage';
import FriendsPage from '@/pages/game/FriendsPage';
import BadgesPage from '@/pages/game/BadgesPage';
import PlayerProfilePage from '@/pages/game/PlayerProfilePage';
import GameSettingsPage from '@/pages/game/GameSettingsPage';
import RankingPage from '@/pages/game/RankingPage';
import ShopPage from '@/pages/game/ShopPage';
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage';
import AdminAgentsPage from '@/pages/admin/AdminAgentsPage';
import AdminPOIsPage from '@/pages/admin/AdminPOIsPage';
import AdminCitiesPage from '@/pages/admin/AdminCitiesPage';
import AdminZonesPage from '@/pages/admin/AdminZonesPage';
import AdminMissionsPage from '@/pages/admin/AdminMissionsPage';
import AdminPartnersPage from '@/pages/admin/AdminPartnersPage';
import AdminOffersPage from '@/pages/admin/AdminOffersPage';
import AdminRedemptionsPage from '@/pages/admin/AdminRedemptionsPage';
import AdminBadgesPage from '@/pages/admin/AdminBadgesPage';
import AdminUsersPage from '@/pages/admin/AdminUsersPage';
import AdminFraudLogsPage from '@/pages/admin/AdminFraudLogsPage';
import AdminAnalyticsPage from '@/pages/admin/AdminAnalyticsPage';
import AdminNotificationsPage from '@/pages/admin/AdminNotificationsPage';
import AdminSuggestionsPage from '@/pages/admin/AdminSuggestionsPage';
import AdminPlaceholderPage from '@/pages/admin/AdminPlaceholderPage';
import LogistaRegisterPage from '@/pages/logista/LogistaRegisterPage';
import LogistaLoginPage from '@/pages/logista/LogistaLoginPage';
import LogistaDashboardPage from '@/pages/logista/LogistaDashboardPage';
import LogistaLojaPage from '@/pages/logista/LogistaLojaPage';
import LogistaOfertasPage from '@/pages/logista/LogistaOfertasPage';
import LogistaResgatesPage from '@/pages/logista/LogistaResgatesPage';
import LogistaAnalyticsPage from '@/pages/logista/LogistaAnalyticsPage';
import LogistaSubscriptionPage from '@/pages/logista/LogistaSubscriptionPage';
import AuthBootstrap from '@/components/auth/AuthBootstrap';
import OfflinePage from '@/pages/OfflinePage';

const routerFuture = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AuthBootstrap />}>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* Logista public */}
      <Route path="/logista/register" element={<LogistaRegisterPage />} />
      <Route path="/logista/login" element={<LogistaLoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/game" element={<GameLayout />}>
          <Route index element={<Navigate to="/game/map" replace />} />
          <Route path="map" element={<MapExplorePage />} />
          <Route path="missions" element={<MissionsPage />} />
          <Route path="characters" element={<CharactersPage />} />
          <Route path="friends" element={<FriendsPage />} />
          <Route path="badges" element={<BadgesPage />} />
          <Route path="profile" element={<PlayerProfilePage />} />
          <Route path="settings" element={<GameSettingsPage />} />
          <Route path="ranking" element={<RankingPage />} />
          <Route path="shop" element={<ShopPage />} />
        </Route>
      </Route>

      <Route element={<AdminRoute />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboardPage />} />
          <Route path="agents" element={<AdminAgentsPage />} />
          <Route path="cities" element={<AdminCitiesPage />} />
          <Route path="zones" element={<AdminZonesPage />} />
          <Route path="pois" element={<AdminPOIsPage />} />
          <Route path="badges" element={<AdminBadgesPage />} />
          <Route path="missions" element={<AdminMissionsPage />} />
          <Route path="partners" element={<AdminPartnersPage />} />
          <Route path="offers" element={<AdminOffersPage />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="redemptions" element={<AdminRedemptionsPage />} />
          <Route path="fraud-logs" element={<AdminFraudLogsPage />} />
          <Route path="analytics" element={<AdminAnalyticsPage />} />
          <Route path="notifications" element={<AdminNotificationsPage />} />
          <Route path="suggestions" element={<AdminSuggestionsPage />} />
          <Route path=":section" element={<AdminPlaceholderPage />} />
        </Route>
      </Route>

      <Route element={<LogistaRoute />}>
        <Route path="/logista" element={<LogistaLayout />}>
          <Route index element={<Navigate to="/logista/dashboard" replace />} />
          <Route path="dashboard" element={<LogistaDashboardPage />} />
          <Route path="loja" element={<LogistaLojaPage />} />
          <Route path="ofertas" element={<LogistaOfertasPage />} />
          <Route path="resgates" element={<LogistaResgatesPage />} />
          <Route path="analytics" element={<LogistaAnalyticsPage />} />
          <Route path="subscription" element={<LogistaSubscriptionPage />} />
        </Route>
      </Route>

      <Route path="/offline" element={<OfflinePage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  ),
  { future: routerFuture }
);

export default function AppRouter() {
  return <RouterProvider router={router} future={routerFuture} />;
}
